import React from "react";
import { Navigation } from "lucide-react";

// Boutons d'itinéraire Google Maps / Waze pour une adresse ou un lieu.
export const DirectionsButtons = ({ destination, className = "" }) => {
  if (!destination) return null;
  const q = encodeURIComponent(destination);
  const maps = `https://www.google.com/maps/dir/?api=1&destination=${q}`;
  const waze = `https://waze.com/ul?q=${q}&navigate=yes`;
  const stop = (e) => e.stopPropagation();
  const base = "inline-flex items-center gap-1 rounded-full bg-secondary hover:bg-secondary/70 px-2.5 py-1 text-xs font-bold text-foreground transition-colors";
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="directions-buttons">
      <a href={maps} target="_blank" rel="noopener noreferrer" onClick={stop} data-testid="directions-maps" className={base}>
        <Navigation size={12} className="text-primary" /> Maps
      </a>
      <a href={waze} target="_blank" rel="noopener noreferrer" onClick={stop} data-testid="directions-waze" className={base}>
        <Navigation size={12} className="text-blue-400" /> Waze
      </a>
    </div>
  );
};
